import { Component, OnInit, OnDestroy } from '@angular/core';

import { KpiData } from '@app/shared/models/ipm/KpiData';
import { FilterViewComplete } from 'app/shared/models/ipm/FilterView';
import { CurrencyView } from "@app/shared/models/ipm/view/CurrencyView";
import { BarChartData } from '@app/shared/models/ipm/BarChartData';

import { TranslateService } from "@ngx-translate/core";
import { MessageService as PrimeMessageService } from 'primeng/api';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { GraphicService } from 'app/services/net-remit/graphic.service';

import { finalize } from 'rxjs/operators';
import { fadeIn } from 'assets/animations/animations';

@Component({
    selector: 'app-charts',
    templateUrl: './charts.component.html',
    styleUrls: ['./charts.component.scss'],
    animations: [fadeIn],
    standalone: false
})

export class ChartsComponent implements OnInit, OnDestroy {

  alive: boolean = true;
  barCharts: BarChartData;
  filtersSelected: FilterViewComplete;
  isIpmConfigured: boolean;
  isLoading: boolean = true;
  emptyCurrency = new CurrencyView(0, '', '');
  generalError: Object = new Object();
  hasError : boolean;
  kpis: Array<KpiData>;
  maxDaysInGraphics: number;
  maxMonthsInGraphics: number;
  messagesError: any;
  userAlocale: string;

  constructor(
    private authenticationService: AuthenticationService,
    private graphicService: GraphicService,
    private primeMessageService: PrimeMessageService,
    private translateService: TranslateService
  ) {
    let credentials = this.authenticationService.credentials;
    this.isIpmConfigured = credentials?.isIpmConfigured;
    this.userAlocale = credentials?.language;
    this.hasError = false;
    this.filtersSelected = new FilterViewComplete(undefined, undefined, [], [], [], this.emptyCurrency, [], [], [], false);
  }

  ngOnInit() {
    if(this.isIpmConfigured){
      this.getConfigParameters();
    } else {
      setTimeout(() => {
        this.primeMessageService.add({
          key: 'toast-charts',
          closable: true,
          sticky: true,
          severity:'error',
          summary: this.translateService.instant('Modal.Error'),
          detail: this.translateService.instant('Error Generic Onload')
        })
      }, 100)
    }
  }

  public stopLoading(error){
    this.isLoading = false;
    if(error.message != null && error.message.length > 0){
      this.primeMessageService.add({
        key: 'toast-charts',
        closable: true,
        sticky: true,
        severity:'error',
        summary: this.translateService.instant('Modal.Error'),
        detail: this.translateService.instant(error.message)
      })
    }
  }

  public getChartsData(filters) {
    this.isLoading = true;
    this.graphicService.getChartsData(filters)
      .pipe( finalize(() => this.isLoading = false ) )
      .subscribe(charts => {
        this.kpis = charts.kpis;
        this.barCharts = charts.barCharts;
        if(!this.kpis){
          this.primeMessageService.add({
            key: 'toast-charts',
            closable: true,
            life: 3000,
            severity: 'warn',
            summary: this.translateService.instant('Modal.Warning'),
            detail: this.translateService.instant('No Results Found Try Other')
          })
        }
      });
  }

  private getConfigParameters(){
    this.graphicService.getConfigGraphicsParameters()
      .subscribe(data => {
        this.maxDaysInGraphics = data.maxDaysInGraphics;
        this.maxMonthsInGraphics = data.maxMonthsInGraphics;
      });
  }

  ngOnDestroy(): void {
		// prevent memory leak when component destroyed
		this.alive = false;
  }
}
